export function isString(obj) {
  return typeof obj === 'string' || obj instanceof String
}

export function capitalize(str) {
  // 文字列の先頭のみ大文字にする
  if (!str || typeof str !== 'string') return str
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}
